import { Box } from '@chakra-ui/react';
import { FC, useMemo, useState, useEffect, useCallback } from 'react';
import { auth } from '../../client/firebase';
import { Loading } from '../../lib/components/Loading';

export const PracticalCoursesPage: FC = () => {
  const [token, setToken] = useState<string>('');

  const url = useMemo(() => {
    return process.env.REACT_APP_MEDQ_URL;
  }, []);

  const getToken = useCallback(async () => {
    const { currentUser } = auth;

    const res = await currentUser?.getIdToken();
    if (res) {
      setToken(res);
    }
  }, []);

  useEffect(() => {
    getToken();
  }, [getToken]);

  if (token.length === 0) {
    return <Loading />;
  }

  return (
    <Box height="calc(100vh - 80px)">
      <iframe
        width="100%"
        height="100%"
        style={{
          height: 'calc(100vh) - 80px)',
        }}
        allowFullScreen
        title="Sprint MedQ"
        src={`${url}aristo/practical-courses/?token=${token}&aristo=true&app=react&route=practical-courses`}
      />
    </Box>
  );
};
